// extracted by mini-css-extract-plugin
export default {"averageContainer":"ReviewStats_averageContainer__4Ya8j","averageRating":"ReviewStats_averageRating__ttUsl"};